import * as THREE from 'three';
import React from 'react';
import { propsAreEqual } from '../../utils'

export function TextureComponent({ 
    loaded, map, setLoaded = (() => { }), setProgress = (() => { }), transparent = false, progress
}) {
    const geometry = new THREE.SphereBufferGeometry(500, 60, 40);
    geometry.computeVertexNormals(true);

    if (!map) return <mesh />;
 
    let manager = new THREE.LoadingManager();

    manager.onStart = function ( url, itemsLoaded, itemsTotal ) {
        if(progress < 10) setProgress(10)
    };
    
    manager.onLoad = function ( ) {
        setProgress(100)
        setTimeout(() => {
            setLoaded(true)
        }, 2000);
    };
    
    
    manager.onProgress = function ( url, itemsLoaded, itemsTotal ) {
        if(progress < 70) setProgress(70)
    };
    manager.onError = function(map) {
        console.log('Error loading texture: ' + map);
    };


    const textureLoader = new THREE.TextureLoader(manager);
    textureLoader.crossOrigin = 'anonymous';
    const texture = textureLoader.load(
        map
      );

    // texture.minFilter = THREE.LinearFilter;
    // texture.magFilter = THREE.LinearFilter;
    texture.premultiplyAlpha = true;
    texture.anisotropy = 16;
    // texture.repeat.set(1.02, 1.02);
    // texture.wrapT = THREE.ClampToEdgeWrapping
    // texture.wrapS = THREE.ClampToEdgeWrapping
    // texture.premultiplyAlpha = true;
    // texture.wrapS = THREE.ClampToEdgeWrapping;
    // texture.wrapT = THREE.ClampToEdgeWrapping;

    const debugXYZ = false;
    return (
        <mesh renderOrder={2} geometry={geometry} position={[0, 0, 0]} scale={[1, 1, -1]} onPointerMove={(e) => debugXYZ && console.log('canvas', [e.point.x.toFixed(0), e.point.y.toFixed(0), e.point.z.toFixed(0)])}>
            <meshBasicMaterial 
                visible={loaded} 
                map={texture} 
                side={THREE.BackSide} 
                // opacity={1} 
                // transparent={true} 
                // needsUpdate={false} 
                // flatShading={THREE.SmoothShading}
                // alphaTest={0.5}
                // depthWrite={false}
                // depthTest={true}
                blending={THREE.CustomBlending}
                blendEquation= {THREE.AddEquation}
                blendSrc=  {THREE.OneFactor}
                blendDst=  {THREE.OneMinusSrcAlphaFactor}
                blendSrcAlpha=  {THREE.OneFactor}
                blendDstAlpha=  {THREE.OneMinusSrcAlphaFactor}
                transparent= {true}
            />
        </mesh>)
}
export const Texture = React.memo(TextureComponent, propsAreEqual)